import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthService from 'services/Auth';
import routeCodes from 'common/constants/route-codes';
import { useUser } from '../../redux/user/use-user';
import { useBootstrapCalls } from '../../hooks/use-bootsrap-calls';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const token = AuthService.getToken();
  const { isSuperAdmin, getInProcess,  } = useUser();
  if (token) {
    if (!getInProcess && !isSuperAdmin) {
      useBootstrapCalls();
    }
  }

  return token ? (
    <Route
      {...rest}
      render={(matchProps) => <Component {...matchProps} />}
    />
  ) : (
    <Redirect to={{
      pathname: routeCodes.signIn, search: window.location.search,
    }} />
  );
};

export default ProtectedRoute;
